import React from 'react';
import {
    MetaSection,
    AssigneeDisplay,
    AssigneeLabel,
    AssigneeAvatar,
    UserName,
    Labels,
    Label,
    AddLabel,
    UnassignButton // Import the new styled component
} from '../../styles/CardModal.styles';

const CardMetaInfo = ({
    assignee,
    cardData,
    labels,
    showAssigneePicker,
    setShowAssigneePicker,
    setShowLabelPicker,
    handleToggleLabel,
    handleUnassign // New prop
}) => {
    return (
        <MetaSection>
            {/* Assignee Section */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <AssigneeDisplay onClick={() => !assignee && setShowAssigneePicker(!showAssigneePicker)}>
                    <AssigneeLabel>Assignee</AssigneeLabel>
                    {assignee ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <AssigneeAvatar src={assignee.photoURL} onClick={() => setShowAssigneePicker(!showAssigneePicker)} style={{cursor: 'pointer'}}>
                                {!assignee.photoURL && (assignee.displayName?.[0] || assignee.email?.[0])}
                            </AssigneeAvatar>
                            <UserName onClick={() => setShowAssigneePicker(!showAssigneePicker)} style={{cursor: 'pointer'}}>
                                {assignee.displayName || assignee.email}
                            </UserName>
                        </div>
                    ) : (
                        <UserName style={{ color: '#B6C2CF', cursor: 'pointer' }} onClick={() => setShowAssigneePicker(!showAssigneePicker)}>Unassigned</UserName>
                    )}
                </AssigneeDisplay>
                {assignee && handleUnassign && (
                    <UnassignButton
                        onClick={(e) => {
                            e.stopPropagation(); // Prevent opening picker
                            handleUnassign();
                        }}
                        title="Remove assignee"
                    >
                        ×
                    </UnassignButton>
                )}
            </div>

            {/* Labels Section */}
            <Labels>
                {cardData.labelIds?.map(labelId => {
                    const label = labels.find(l => l.id === labelId);
                    if (!label) return null;
                    return (
                        <Label
                            key={labelId}
                            color={label.color}
                            onClick={() => handleToggleLabel(labelId)}
                        >
                            {label.title}
                        </Label>
                    );
                })}
                <AddLabel onClick={() => setShowLabelPicker(true)}>
                    + Add Label
                </AddLabel>
            </Labels>
        </MetaSection>
    );
};

export default CardMetaInfo;